/**
 * Fishermans — carrinho: liga os botoes do card de KIT.
 *
 * O CARD NAO NASCE AQUI. Ele e impresso pelo Liquid, em
 * snippets/cart-drawer.liquid, junto com o resto do carrinho. Este arquivo so
 * liga tres botoes (ver itens / +- / lixeira) e cuida do estado "ocupado".
 *
 * POR QUE MUDOU
 *   A versao anterior desenhava o card por JS depois que a gaveta voltava do
 *   servidor. Duas consequencias, as duas o Jorge pegou na mao:
 *
 *   1. PISCA — o HTML que volta do Shopify e a lista crua do kit. Ela
 *      aparecia na tela ate o script agrupar. Com o card vindo do Liquid nao
 *      ha "ate": ja chega agrupado.
 *
 *   2. FURO — as travas (quantidade, lixeira, link) eram uma classe que este
 *      script adicionava. Entre o re-render e o script rodar havia ~200ms com
 *      tudo liberado, inclusive o "+" do brinde a R$ 0. Foram tres furos pelo
 *      mesmo motivo. Agora quem carimba a linha e o Liquid, em todo render.
 *      Se ESTE ARQUIVO NAO CARREGAR, nada fica exposto: as linhas continuam
 *      recolhidas e travadas, o cliente so perde o botao de expandir.
 *
 * REGRA QUE NAO SE QUEBRA: nada aqui apaga linha do carrinho por conta
 * propria. So o clique do cliente na lixeira do card remove — e remove o kit
 * inteiro, achando as linhas pela PROPERTY, nunca pela posicao na tela. Era a
 * posicao que fazia o brinde sumir quando entrava outro produto.
 */
(function () {
  "use strict";

  try { if (window.Shopify && window.Shopify.designMode) return; } catch (e) { return; }

  var SECOES = "cart-drawer,cart-icon-bubble";
  var abertos = Object.create(null);   /* chave do kit -> lista expandida */
  var observador = null;

  /* ── mesma regra do snippets/fm-kit-chave.liquid ──────────────────────
     Se as duas divergirem, o card some ou agrupa errado. Por isso a ordem
     esta escrita igual nos dois lugares: _KitId, _KitHandle, Kit. */
  function chaveDe(props) {
    if (!props || !props["Kit"]) return "";
    return props["_KitId"] || props["_KitHandle"] || props["Kit"];
  }

  /* ══ ESTADO OCUPADO ══════════════════════════════════════════════════
   * Conta as chamadas a /cart/* em voo e marca o <html>. Pega TODO mundo:
   * os botoes do proprio tema, o guard e este arquivo. Enquanto houver uma
   * em voo o "Finalizar a compra" fica desabilitado de verdade (nao so
   * apagado no CSS — senao o Enter no botao focado ainda envia).
   */
  var emVoo = 0;
  var desligadosPorMim = [];

  function botoesCheckout() {
    try {
      return document.querySelectorAll(
        '[name="checkout"], #CartDrawer-Checkout, #cart-drawer-checkout, .cart__checkout-button'
      );
    } catch (e) { return []; }
  }

  function pintarOcupado() {
    try {
      if (emVoo > 0) {
        document.documentElement.setAttribute("data-fm-cart-busy", "1");
        Array.prototype.forEach.call(botoesCheckout(), function (b) {
          if (b.disabled) return;           /* ja estava desabilitado (carrinho vazio) */
          b.disabled = true;
          desligadosPorMim.push(b);
        });
      } else {
        document.documentElement.removeAttribute("data-fm-cart-busy");
        desligadosPorMim.forEach(function (b) {
          try { b.disabled = false; } catch (e) {}
        });
        desligadosPorMim = [];
      }
    } catch (e) {}
  }

  function ocupar() { emVoo++; pintarOcupado(); }
  function liberar() { emVoo = Math.max(0, emVoo - 1); pintarOcupado(); }

  try {
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === "function") {
      window.fetch = function (entrada, opcoes) {
        var url = "";
        try {
          url = typeof entrada === "string" ? entrada : (entrada && entrada.url) || "";
        } catch (e) { url = ""; }

        var mexeNoCarrinho = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
        if (!mexeNoCarrinho) return fetchOriginal.apply(this, arguments);

        ocupar();
        var p;
        try {
          p = fetchOriginal.apply(this, arguments);
        } catch (e) {
          liberar();
          throw e;
        }
        /* solta nos dois desfechos; o .then extra nao consome o corpo */
        return p.then(
          function (r) { liberar(); return r; },
          function (e) { liberar(); throw e; }
        );
      };
    }
  } catch (e) {}

  /* rede caiu / aba voltou do bfcache: nao deixa o carrinho travado ocupado */
  window.addEventListener("pageshow", function () { emVoo = 0; pintarOcupado(); });

  /* ══ AVISO "Adicionando kit..." ══════════════════════════════════════
   * Chamado pelo fishermans-cart-guard.js quando o cliente adiciona um kit.
   * A gaveta abre na hora com o aviso, igual a Dr. Squatch, em vez de ficar
   * um tempo sem resposta e so entao aparecer tudo de uma vez.
   */
  function gaveta() {
    try { return document.querySelector("cart-drawer"); } catch (e) { return null; }
  }

  function aviso(texto) {
    try {
      limparAviso();
      var d = gaveta();
      if (!d) return;
      var alvo = d.querySelector(".drawer__inner") || d.querySelector(".drawer__contents") || d;
      if (getComputedStyle(alvo).position === "static") alvo.style.position = "relative";
      var bar = document.createElement("div");
      bar.className = "fm-addingbar";
      bar.setAttribute("data-fm-addingbar", "1");
      bar.setAttribute("role", "status");
      bar.innerHTML =
        '<div class="fm-addingbar__spin" aria-hidden="true"></div>' +
        '<p class="fm-addingbar__txt"></p>';
      bar.querySelector(".fm-addingbar__txt").textContent = texto || "Adicionando ao carrinho…";
      alvo.appendChild(bar);
    } catch (e) {}
  }

  function limparAviso() {
    try {
      document.querySelectorAll("[data-fm-addingbar]").forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    } catch (e) {}
  }

  window.FMCart = window.FMCart || {};
  window.FMCart.aviso = aviso;
  window.FMCart.limparAviso = limparAviso;

  /* ══ RE-INJECAO DA GAVETA ════════════════════════════════════════════ */

  function injetar(sid, html) {
    if (!html) return false;
    try {
      var wrap = document.getElementById("shopify-section-" + sid);
      if (!wrap) return false;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresco = doc.getElementById("shopify-section-" + sid);
      wrap.innerHTML = fresco ? fresco.innerHTML : html;
      return true;
    } catch (e) { return false; }
  }

  /* O <cart-drawer> volta do servidor SEM "active" (e com "is-empty" se o
     carrinho passou por vazio). Sem isto a gaveta some da tela e parece que
     travou, embora a acao tenha acontecido. */
  function reabrirGaveta() {
    try {
      var d = gaveta();
      if (!d) return;
      if (d.querySelector(".cart-item") && d.classList.contains("is-empty")) {
        d.classList.remove("is-empty");
      }
      if (d.classList.contains("active")) return;
      if (typeof d.open === "function") { d.open(); return; }
      d.classList.add("active");
    } catch (e) {}
  }

  /* ══ QUANTIDADE DO KIT ═══════════════════════════════════════════════
   * Uma chamada so, com o array completo. Mexer linha a linha embaralha os
   * indices no meio do caminho.
   *
   * As linhas do grupo sao achadas pela PROPERTY (chaveDe), lendo /cart.js —
   * nunca pela posicao na tela. A tela se redesenha a cada mudanca; foi
   * confiar nela que fez a regra antiga apagar o brinde do cliente.
   *
   * nova = 0 remove o kit inteiro.
   */
  function aplicarQtd(chave, nova) {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var achou = false;
        var qtds = cart.items.map(function (it) {
          if (chaveDe(it.properties) === chave) { achou = true; return nova; }
          return it.quantity;
        });
        /* nao encontrou o grupo: o carrinho mudou embaixo de nos. Nao chuta
           indice nenhum — so redesenha. */
        if (!achou) { window.location.reload(); return null; }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            updates: qtds,
            sections: SECOES,
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); });
      })
      .then(function (data) {
        if (!data) return;
        var ok = false;
        if (data.sections) {
          Object.keys(data.sections).forEach(function (sid) {
            if (injetar(sid, data.sections[sid])) ok = true;
          });
        }
        if (!ok) { window.location.reload(); return; }
        if (nova === 0) delete abertos[chave];
        aplicarAberto();
        reabrirGaveta();
        limparAviso();
      })
      .catch(function () { window.location.reload(); });
  }

  /* ══ ACORDEAO ════════════════════════════════════════════════════════
   * O carrinho e redesenhado inteiro a cada mudanca, entao o estado
   * aberto/fechado precisa viver fora do DOM. Padrao: FECHADO. Se o cliente
   * abriu para conferir, continua aberto depois de mexer na quantidade —
   * em vez de fechar na cara dele a cada clique.
   */
  function aplicarAberto() {
    try {
      if (observador) observador.disconnect();
      document.querySelectorAll(".fm-kitcard[data-fm-kitcard]").forEach(function (card) {
        var chave = card.getAttribute("data-fm-kitcard");
        var aberto = !!abertos[chave];
        var botao = card.querySelector(".fm-kitcard__toggle");
        if (botao) {
          botao.setAttribute("aria-expanded", aberto ? "true" : "false");
          var txt = botao.querySelector(".fm-kitcard__toggle-txt");
          if (txt) txt.textContent = aberto ? "Ocultar itens do kit" : "Ver itens do kit";
        }
        document.querySelectorAll('.cart-item.fm-kit-line[data-fm-kit]').forEach(function (li) {
          if (li.getAttribute("data-fm-kit") !== chave) return;
          if (aberto) li.removeAttribute("hidden");
          else li.setAttribute("hidden", "hidden");
        });
      });
    } catch (e) {} finally {
      ligarObservador();
    }
  }

  function ligarObservador() {
    try {
      if (!document.body) return;
      if (!observador) {
        var t;
        observador = new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(aplicarAberto, 40);
        });
      }
      observador.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* ══ CLIQUES ═════════════════════════════════════════════════════════
   * Delegacao no document: sobrevive a todo re-render sem precisar religar
   * nada. Era a religacao que ficava para tras e deixava o card morto.
   */
  document.addEventListener("click", function (evt) {
    var alvo = evt.target;
    if (!alvo || !alvo.closest) return;

    var toggle = alvo.closest(".fm-kitcard__toggle");
    if (toggle) {
      evt.preventDefault();
      var k = toggle.getAttribute("data-fm-kit-toggle");
      if (!k) return;
      if (abertos[k]) delete abertos[k]; else abertos[k] = true;
      aplicarAberto();
      return;
    }

    var mais = alvo.closest("[data-fm-qty]");
    if (mais) {
      evt.preventDefault();
      if (emVoo > 0) return;
      var chave = mais.getAttribute("data-fm-kit");
      var card = mais.closest(".fm-kitcard");
      var valEl = card && card.querySelector("[data-fm-qty-val]");
      var atual = valEl ? parseInt(valEl.textContent, 10) : NaN;
      var passo = parseInt(mais.getAttribute("data-fm-qty"), 10);
      if (!chave || isNaN(atual) || isNaN(passo)) return;
      var nova = atual + passo;
      if (nova < 1) return;              /* pra zerar existe a lixeira */
      aplicarQtd(chave, nova);
      return;
    }

    var lixo = alvo.closest(".fm-kitcard__remove");
    if (lixo) {
      evt.preventDefault();
      if (emVoo > 0) return;
      var c = lixo.getAttribute("data-fm-kit");
      if (c) aplicarQtd(c, 0);
    }
  });

  function ligar() {
    aplicarAberto();   /* ja liga o observador no finally */
    pintarOcupado();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ligar);
  } else {
    ligar();
  }
})();
